module.exports = __webpack_public_path__ + "img/delete.7c9993e1.svg";